import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from '../../../shared/i18n';

/** IP 的 DDoS 防护量标签(Gbps;空 = 不显示) */
export const ddosText = (t, gbps) => (gbps ? t('{{n}}G DDoS', { n: gbps }) : '');

const DdosTag = ({ gbps }) => {
    const { t } = useTranslation();
    if (!gbps) return null;
    return <Tag color="volcano" style={{ marginInlineEnd: 0 }}>{ddosText(t, gbps)}</Tag>;
};

export default DdosTag;
